import { Link } from 'react-router-dom';

import LogoFooterSvg from '1_shared/assets/pictures/logo-footer.svg';
import LogoFooterMobileSvg from '1_shared/assets/pictures/logo-footer-mobile.svg';

import { ReactComponent as TelegramIcon } from '../../../assets/pictures/telegram.svg';
import { TelegramHelpLink } from '../../../constants/TelegramHelpLink';
import { Typography } from '../../index';
import { footerLinks, footerSocialsLinks } from '../config/footerLinks';

import 'app/styles/global/global.scss';
import './footer.scss';
import styles from './Footer.module.scss';
import cn from 'classnames';
import pdf_dataProcessing from '../../../assets/docs/Договор_Обработки_персональных_данных_специалист_DoTherapy.pdf';

const Footer = () => (
  <footer className={styles.root}>
    <div className={styles.container}>
      <div className={styles.logoWrapper}>
        <a href="/" className={styles.logo}>
          <picture>
            <source media="(max-width: 768px)" srcSet={LogoFooterMobileSvg} />
            <img
              src={LogoFooterSvg}
              alt="Dotherapy ваша точка опоры"
              width="146"
              height="44"
            />
          </picture>
        </a>
      </div>
      <div className={styles.contactsWrapper}>
        <div className={styles.telegramContainer}>
          <div className={styles.telegram}>
            <TelegramIcon />
            <Typography className={styles.needHelp}>Нужна помощь?</Typography>
          </div>
          <a className={styles.textUs} href={TelegramHelpLink}>
            Напишите нам
          </a>
        </div>
        <div className={styles.emailContainer}>
          <Typography className={styles.emailLabel}>Email</Typography>
          <a href="mailto:info@dotherapy.ru" className={styles.email}>
            info@dotherapy.ru
          </a>
        </div>
        <div className={styles.phoneNumberContainer}>
          <Typography className={styles.phoneLabel}>Номер телефона</Typography>
          <a href="tel:89154701817" className={styles.phoneNumber}>
            +7 (915) 470-18-17
          </a>
        </div>
      </div>

      <div className={styles.navigationLinksWrapper}>
        {footerLinks.map(item =>
          item.isAppLink ? (
            <Link key={item.label} to={item.url} className={styles.navLinkItem}>
              {item.label}
            </Link>
          ) : (
            <a key={item.label} href={item.url} className={styles.navLinkItem}>
              {item.label}
            </a>
          ),
        )}
      </div>

      <div className={styles.descriptionContainer}>
        <Typography className={styles.description}>
          Под психотерапией на сайте понимается психологическая психотерапия —
          нелекарственный способ оздоровления психической системы. Специалисты
          платформы являются психологами и немедицинскими психотерапевтами, и не
          оказывают медицинских услуг.
        </Typography>
      </div>

      <div className={styles.footerSocialsWrapper}>
        <Typography className={styles.weAreInSocialMedia}>
          Мы в социальных сетях
        </Typography>
        <div className={styles.socialsList}>
          {footerSocialsLinks.map(social => (
            <a
              key={social.id}
              href={social.link}
              aria-label={social.id}
              className={cn(social.iconClassName, styles.socialItem)}
            />
          ))}
        </div>
      </div>

      <a href={pdf_dataProcessing} className={styles.terms}>
        Условия обработки данных
      </a>
      <a
        href="https://docs.google.com/document/d/1MEXfHKppmUVnfBEJNmSKZu7sIkh4Cj6BOo6ugjyRUUA/edit?usp=sharing"
        className={styles.agreement}
      >
        Пользовательское соглашение
      </a>
      <Typography className={styles.copyRight}>
        © 2025 ООО «Психологические консультации онлайн» ИНН 7730264961 ОГРН
      </Typography>
    </div>
  </footer>
);

export default Footer;
